"use client";

import Link from "next/link";
import React from "react";

export const AnnouncementBar: React.FC = () => {
  return (
    <div>
      <Link
        href="https://vidmuse.ai/blog/see-your-rhythm-videmuse-global-search"
        target="_blank"
      >
        <img
          src="https://static.sandcdn.com/uploads/adc5fbab-9c45-42d6-b5a6-0a47de0c5453.jpg"
          alt="See your Rhythm"
          className="w-full h-12 object-cover"
        />
      </Link>
    </div>
  );
};
